"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTitle = exports.useTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _isNode = _interopRequireDefault(require("./isNode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentTitle = '';
/**
 * This hook will set the window title, when a component gets mounted.
 * When the component gets unmounted, the previously used title will be restored.
 * @param {string} inString
 */

var useTitle = function useTitle(inString) {
  currentTitle = inString;

  if (_isNode.default) {
    return;
  }

  _react.default.useEffect(function () {
    var previousTitle = document.title;
    document.title = inString;
    return function () {
      document.title = previousTitle;
    };
  });
};
/**
 * Returns the current window title to be used in a SSR context
 * @returns {string}
 */


exports.useTitle = useTitle;

var getTitle = function getTitle() {
  return currentTitle;
};

exports.getTitle = getTitle;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy90aXRsZS5qcyJdLCJuYW1lcyI6WyJjdXJyZW50VGl0bGUiLCJ1c2VUaXRsZSIsImluU3RyaW5nIiwiaXNOb2RlIiwiUmVhY3QiLCJ1c2VFZmZlY3QiLCJwcmV2aW91c1RpdGxlIiwiZG9jdW1lbnQiLCJ0aXRsZSIsImdldFRpdGxlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7Ozs7QUFFQSxJQUFJQSxZQUFZLEdBQUcsRUFBbkI7QUFFQTs7Ozs7O0FBS08sSUFBTUMsUUFBUSxHQUFHLFNBQVhBLFFBQVcsQ0FBQ0MsUUFBRCxFQUFjO0FBQ3JDRixFQUFBQSxZQUFZLEdBQUdFLFFBQWY7O0FBRUEsTUFBR0MsZUFBSCxFQUFVO0FBQ1Q7QUFDQTs7QUFFREMsaUJBQU1DLFNBQU4sQ0FBZ0IsWUFBTTtBQUNyQixRQUFNQyxhQUFhLEdBQUdDLFFBQVEsQ0FBQ0MsS0FBL0I7QUFDQUQsSUFBQUEsUUFBUSxDQUFDQyxLQUFULEdBQWlCTixRQUFqQjtBQUNBLFdBQU8sWUFBTTtBQUNaSyxNQUFBQSxRQUFRLENBQUNDLEtBQVQsR0FBaUJGLGFBQWpCO0FBQ0EsS0FGRDtBQUdBLEdBTkQ7QUFPQSxDQWRNO0FBZ0JQOzs7Ozs7OztBQUlPLElBQU1HLFFBQVEsR0FBRyxTQUFYQSxRQUFXO0FBQUEsU0FBTVQsWUFBTjtBQUFBLENBQWpCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IGlzTm9kZSBmcm9tICcuL2lzTm9kZSc7XHJcblxyXG5sZXQgY3VycmVudFRpdGxlID0gJyc7XHJcblxyXG4vKipcclxuICogVGhpcyBob29rIHdpbGwgc2V0IHRoZSB3aW5kb3cgdGl0bGUsIHdoZW4gYSBjb21wb25lbnQgZ2V0cyBtb3VudGVkLlxyXG4gKiBXaGVuIHRoZSBjb21wb25lbnQgZ2V0cyB1bm1vdW50ZWQsIHRoZSBwcmV2aW91c2x5IHVzZWQgdGl0bGUgd2lsbCBiZSByZXN0b3JlZC5cclxuICogQHBhcmFtIHtzdHJpbmd9IGluU3RyaW5nXHJcbiAqL1xyXG5leHBvcnQgY29uc3QgdXNlVGl0bGUgPSAoaW5TdHJpbmcpID0+IHtcclxuXHRjdXJyZW50VGl0bGUgPSBpblN0cmluZztcclxuXHJcblx0aWYoaXNOb2RlKXtcclxuXHRcdHJldHVybjtcclxuXHR9XHJcblxyXG5cdFJlYWN0LnVzZUVmZmVjdCgoKSA9PiB7XHJcblx0XHRjb25zdCBwcmV2aW91c1RpdGxlID0gZG9jdW1lbnQudGl0bGU7XHJcblx0XHRkb2N1bWVudC50aXRsZSA9IGluU3RyaW5nO1xyXG5cdFx0cmV0dXJuICgpID0+IHtcclxuXHRcdFx0ZG9jdW1lbnQudGl0bGUgPSBwcmV2aW91c1RpdGxlO1xyXG5cdFx0fTtcclxuXHR9KTtcclxufTtcclxuXHJcbi8qKlxyXG4gKiBSZXR1cm5zIHRoZSBjdXJyZW50IHdpbmRvdyB0aXRsZSB0byBiZSB1c2VkIGluIGEgU1NSIGNvbnRleHRcclxuICogQHJldHVybnMge3N0cmluZ31cclxuICovXHJcbmV4cG9ydCBjb25zdCBnZXRUaXRsZSA9ICgpID0+IGN1cnJlbnRUaXRsZTtcclxuIl19